import React from "react";
import { withRouter } from "react-router-dom";
import { Image, Typography } from "antd";
import Veikul from "./logoNew.png";
import { NavbarContainer } from "./elements";
import { useUser } from "providers/user";
const { Text } = Typography;

function NavBar() {
  const {
    user: { lead },
  } = useUser();

  return (
    <NavbarContainer>
      <div
        style={{
          display: "flex",
          paddingTop: 20,
          width: "100%",
          flexDirection: "column",
          justifyContent: "center",
        }}
      >
        <div style={{ marginLeft: "auto", marginRight: "auto" }}>
          <Image height={42} width={220} src={Veikul} alt="" preview={false} />
        </div>

        <Text strong style={{ textAlign: "center", color: "white" }}>
          Bienvenido, {lead?.firstName} {lead?.lastName}
        </Text>
      </div>
    </NavbarContainer>
  );
}

export default withRouter(NavBar);
